import dagre from "dagre";
import {FlowEdge, FlowLayoutOptions, FlowNode} from "./types";

export const layoutFlow = (nodes: FlowNode[], edges: FlowEdge[], options: FlowLayoutOptions = {}) => {
    const dagreGraph = new dagre.graphlib.Graph();
    dagreGraph.setDefaultEdgeLabel(() => ({}));
    dagreGraph.setGraph({
        rankdir: "LR",
        ranker: "longest-path",
        nodesep: options.nodeSep ?? 50,
        ranksep: options.rankSep ?? 90
    });

    const nodeIds = new Set(nodes.map((node) => node.id));
    nodes.forEach((node) => {
        dagreGraph.setNode(node.id, {width: node.width, height: node.height});
    });
    edges
        .filter((edge) => nodeIds.has(edge.fromId) && nodeIds.has(edge.toId))
        .forEach((edge) => {
            dagreGraph.setEdge(edge.fromId, edge.toId);
        });

    dagre.layout(dagreGraph);

    const laidOutNodes = nodes.map((node) => {
        const pos = dagreGraph.node(node.id);
        return {
            ...node,
            x: pos.x - node.width / 2,
            y: pos.y - node.height / 2
        };
    });

    return {nodes: laidOutNodes, edges};
};
